<template>
	<div>
		<div class="box-cards">
			<template v-for="premioSelecao in premiosSelecionar">
				<c-cp-premio-selecionar inline-template :premio-id="premioSelecao.id" :key="premioSelecao.id">
					<div class="column-3">
						<div class="title" style="border-color: #1d1e34;">{{ premioSelecao.referencia }} - {{ premioSelecao.nome }}</div>
						<div class="box-imagem">
							<img :src="premioSelecao.imagem" alt="premioSelecao.nome">
						</div>
						<span>Foto meramente ilustrativa</span>
						<div class="box-left">
							<div class="box-flex">
								<div class="left-box">
									<div class="quantidade-pontos">{{ premioSelecao.pontuacao_unitaria }}</div>
									<div class="pontos">pontos/un.</div>
								</div>
								<div class="right-box">
									<div class="quantidade" v-show="premioAdicionado == -1">Quantidade:</div>
									<div class="input-number" v-show="premioAdicionado == -1">
										<button type="button" v-on:click="decrementaPremio"><i class="fas fa-chevron-down"></i></button>
										<input type="text" name="number" min="1" max="1000" value="1" readonly v-model="quantidade">
										<button type="button" v-on:click="incrementaPremio"><i class="fas fa-chevron-up"></i></button>
									</div>
									<div class="quantidade" v-show="premioAdicionado != -1">Selecionado:</div>
									<div class="input-number" v-show="premioAdicionado != -1" style="text-align: center;">
										<strong>{{ premioQuantidadeAdicionado }}</strong>
									</div>
								</div>
							</div>
							<button tipe="button" class="btn-padrao btn-adicionar selecionar-item" v-on:click="adicionaPremio" v-show="premioAdicionado == -1">
								Selecionar item
							</button>
							<a :href="'resgate-pontos-premios-selecionados'" class="btn-padrao btn-adicionar selecionar-item" style="" v-show="premioAdicionado != -1">Resgatar por Pontos</a>
						</div>
					</div>
				</c-cp-premio-selecionar>
			</template>
		</div>
		<div v-if="!loading">
			<br>
			<infinite-loading ref="infinite" @infinite="infiniteHandler">
				<div slot="spinner">
					<vue-element-loading :active="true" spinner="bar-fade-scale"/>
				</div>
				<div style="font-size: 0.9em" slot="no-results">
					<small v-if="premiosSelecionar.length === 0">Não há prêmios disponíveis para resgate no momento.</small>
				</div>
				<div style="display: none;" slot="no-more"></div>
			</infinite-loading>
		</div>
		<vue-element-loading :active="isLoading" is-full-screen></vue-element-loading>
	</div>
</template>
<script>
	import { mapGetters, mapState } from 'vuex';
	import formatMixin from '../../../../../../../../../resources/assets/js/mixins/formatMixin';

	export default
	{
		mixins: [formatMixin],
		props : { },
		data() {
			return {
				premiosSelecionar: [],
				request: { page: 1 },
				loading: false,
				root: ROOT_URL,
				app: APP_URL
			};
		},
		computed: {
			...mapState({
				saldoCampanhaPontos: state => state.campanhapontos.saldoCampanhaPontos,
				premios: state => state.campanhapontos.premios,
				isLoading: state => state.campanhapontos.isLoading
			})
		},
		methods: {
			infiniteHandler($state = { loaded() {}, complete() {} })
			{
				this.axios.post(API_URL + '/campanha-pontos/resgate-pontos-listar-premios-selecao', this.request)
				.then(({data}) =>
				{
					if (data.dadosListagem.length > 0)
					{
						this.premiosSelecionar = this.premiosSelecionar.concat(data.dadosListagem);
						this.request.page++;
						$state.loaded();
					}
					else
					{
						$state.complete();
					}

					if (this.loading)
					{
						this.loading = false;
					}
				})
			}
		},
		mounted() {
			this.loading = true;
			this.infiniteHandler();
		}
	};
</script>